import moment from "moment";

export const monthOptions = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];


export const findDateTimeRange = (data, datetimeKey = "datetime") => {

  if (!Array.isArray(data) || data.length === 0) {
    throw new Error("Input must be a non-empty array of objects.");
  }

  const { minDateTime, maxDateTime } = data.reduce(
    (acc, curr) => {
      const currentDateTime = new Date(curr[datetimeKey]);
      // Update minimum datetime
      if (currentDateTime < new Date(acc.minDateTime)) {
        acc.minDateTime = curr[datetimeKey];
      }

      // Update maximum datetime
      if (currentDateTime > new Date(acc.maxDateTime)) {
        acc.maxDateTime = curr[datetimeKey];
      }

      return acc;
    },
    {
      minDateTime: data[0][datetimeKey], // Initialize with the first object's datetime
      maxDateTime: data[0][datetimeKey],
    }
  );
  return { minDateTime, maxDateTime };
}

// Utility function to get timestamps from an array of objects
export const getEarliestAndLatestTimestamps = (dataArray, dateKey) => {
  if (!dataArray || dataArray.length === 0) return { earliestIso: null, latestIso: null };

  const timestamps = dataArray.map(item => moment(item[dateKey]).toISOString());

  return {
    earliestIso: timestamps.reduce((min, current) => (current < min ? current : min)),
    latestIso: timestamps.reduce((max, current) => (current > max ? current : max)),
  };
};

export const orderByTimestamp = (data, key = "datetime", order = "desc") => {
  if (!Array.isArray(data)) {
    throw new Error("Data must be an array");
  }

  return data.sort((a, b) => {
    const dateA = moment(a[key]);
    const dateB = moment(b[key]);
    return order === "asc" ? dateA.diff(dateB) : dateB.diff(dateA);
  });
};